import { apiService } from './apiService';
import { API_ENDPOINTS } from '../constants';

export const clientService = {
  // Register new client
  register: async (clientData) => {
    try {
      console.log('Client service - sending registration request:', clientData);
      const response = await apiService.post(API_ENDPOINTS.CLIENTS.REGISTER, clientData);
      console.log('Client service - registration response:', response.data);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Client service - registration error:', error.response?.data || error.message);
      return {
        success: false,
        error: error.response?.data?.error || error.message,
        details: error.response?.data?.details
      };
    }
  },

  // Get client by ID
  getById: async (clientId) => {
    try {
      const response = await apiService.get(`${API_ENDPOINTS.CLIENTS.GET_BY_ID}/${clientId}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message
      };
    }
  },

  // Get client dashboard data
  getDashboard: async (clientId) => {
    try {
      const response = await apiService.get(`${API_ENDPOINTS.CLIENTS.DASHBOARD}/${clientId}/dashboard`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message
      };
    }
  },

  // Validate API key
  validateApiKey: async (apiKey) => {
    try {
      const response = await apiService.post(API_ENDPOINTS.CLIENTS.VALIDATE_API_KEY, {}, {
        headers: { 'x-api-key': apiKey }
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message
      };
    }
  }
}; 